import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['searchInput', 'addMembersButton', 'addUserButton'];

  static values = {
    programId: String,
    confirmAllow: String,
    confirmCancel: String,
    confirmTitle: String,
    confirmMessage: String
  }

  connect() {
    this.selectedUserIds = new Set();

    document.addEventListener('promote:data-table:selection', this.setUserIds.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:data-table:selection', this.setUserIds.bind(this));
  }

  setUserIds(event) {
    let selectedItems = event.detail.selectedItems;
    let selectedIds = [...selectedItems.values()].map((entry) => entry.id);

    this.selectedUserIds = new Set(selectedIds);

    if (this.selectedUserIds.size > 0) {
      this.addMembersButtonTarget.disabled = false
    } else {
      this.addMembersButtonTarget.disabled = true
    }
  }

  openForm() {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const params = new URLSearchParams();
    Array.from(this.selectedUserIds).forEach(id => params.append('user_ids[]', id));

    const url = `/admin/programs/${this.programIdValue}/members/new?${params.toString()}`;

    this.load(url);
  }

  newUserForm(event) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    let searchInput = this.element.querySelector('input[name="search"]');

    const params = new URLSearchParams();
    params.set('search', searchInput.value);

    const url = `/admin/programs/${this.programIdValue}/program_users/new?${params.toString()}`;

    this._handleSelection(event, url);
  }

  cancel(event) {
    if (this.ajaxRequest) {
      this.ajaxRequest.abort();
    }

    const url = `/admin/programs/${this.programIdValue}/members?tab_switched=1`;

    this._handleSelection(event, url);
  }

  _handleSelection(event, url) {
    const requiresConfirmation = this.selectedUserIds.size > 0;

    if (requiresConfirmation) {
      const confirmed = Rails.confirm(null, event.target, this._confirmationModalDataset());

      if (!confirmed) {
        return;
      }
    }

    this.load(url);
  }

  _confirmationModalDataset() {
    return {
      confirmError: true,
      confirmCancel: this.confirmCancelValue,
      confirmAllow: this.confirmAllowValue,
      confirmMessage: this.confirmMessageValue,
      confirmTitle: this.confirmTitleValue
    };
  }

  load(url) {
    Rails.ajax({
      url: url,
      type: 'GET',
      dataType: 'script',
      beforeSend: (xhr) => {
        this.ajaxRequest = xhr;
        return true;
      }
    })
  }
}
